import { render, staticRenderFns } from "./SearchDemo.vue?vue&type=template&id=344ba9a4&scoped=true&"
import script from "./SearchDemo.vue?vue&type=script&lang=js&"
export * from "./SearchDemo.vue?vue&type=script&lang=js&"
import style0 from "./SearchDemo.vue?vue&type=style&index=0&id=344ba9a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344ba9a4",
  null
  
)

export default component.exports